/* ═══════════════════════════════════════════
   BLACKOUT — Homepage JS for Horizon
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Scroll fade-up ── */
  const fadeObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('bo-visible'); });
  }, { threshold: 0.10 });
  document.querySelectorAll('.bo-fade-up').forEach(el => fadeObs.observe(el));

  /* ── Cart count refresh ── */
  async function refreshCart() {
    try {
      const r    = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      document.querySelectorAll(
        '[data-cart-count], .cart-count-bubble, .bo-cart-count, .header__cart-count-bubble'
      ).forEach(el => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    } catch (_) {}
  }

  /* ── Notification popup ── */
  function showNotif(title) {
    const n = document.getElementById('bo-cart-notif');
    const s = document.getElementById('bo-cart-notif-sub');
    if (!n) return;
    if (s) s.textContent = title;
    n.classList.add('bo-show');
    clearTimeout(n._t);
    n._t = setTimeout(() => n.classList.remove('bo-show'), 3200);
  }

  /* ── Ticker pause on hover ── */
  document.querySelectorAll('.bo-ticker__track').forEach(t => {
    t.closest('.bo-ticker')?.addEventListener('mouseenter', () => t.style.animationPlayState = 'paused');
    t.closest('.bo-ticker')?.addEventListener('mouseleave', () => t.style.animationPlayState = 'running');
  });

  /* ══════════════════════════════════════════
     GLOBAL FUNCTIONS — called via onclick
     These must be on window so they work from
     any section's HTML
  ══════════════════════════════════════════ */

  /* Core AJAX add to cart */
  window.boDoAddToCart = async function(variantId, btn, originalText) {
    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });
      if (!res.ok) { const e = await res.json(); throw new Error(e.description || 'Failed'); }
      const item = await res.json();
      await refreshCart();
      showNotif(item.title);
      if (btn) {
        btn.classList.add('bo-added');
        btn.textContent = 'Added ✓';
        setTimeout(() => {
          btn.classList.remove('bo-added');
          btn.textContent = originalText || 'Add to Bag';
          btn.disabled = false;
        }, 1600);
      }
    } catch (err) {
      console.error('BLACKOUT cart error:', err);
      if (btn) {
        btn.textContent = originalText || 'Add to Bag';
        btn.disabled = false;
      }
    }
  };

  /* Called from "Add to Bag" button on product cards */
  window.boAddToCart = function(btn) {
    const variantId   = btn.dataset.variantId;
    const hasVariants = btn.dataset.hasVariants;
    const productUrl  = btn.dataset.productUrl;
    const orig        = btn.textContent;

    /* Multiple variants → go to product page to pick size */
    if (hasVariants === 'true' || !variantId || variantId === 'undefined') {
      window.location.href = productUrl;
      return;
    }

    btn.disabled    = true;
    btn.textContent = 'Adding...';
    btn.classList.add('bo-adding');
    window.boDoAddToCart(variantId, btn, orig);
  };

  /* Called from + quick add button on product card image */
  window.boQuickAdd = function(btn) {
    const variantId   = btn.dataset.variantId;
    const hasVariants = btn.dataset.hasVariants;
    const productUrl  = btn.dataset.productUrl;
    const icon        = btn.querySelector('.bo-qa-icon');

    if (hasVariants === 'true' || !variantId || variantId === 'undefined') {
      window.location.href = productUrl;
      return;
    }

    btn.classList.add('bo-loading');
    if (icon) icon.textContent = '···';

    window.boDoAddToCart(variantId, null, null).then(() => {
      btn.classList.remove('bo-loading');
      btn.classList.add('bo-success');
      if (icon) icon.textContent = '✓';
      setTimeout(() => {
        btn.classList.remove('bo-success');
        if (icon) icon.textContent = '+';
      }, 1600);
    }).catch(() => {
      btn.classList.remove('bo-loading');
      if (icon) { icon.textContent = '!'; setTimeout(() => icon.textContent = '+', 1600); }
    });
  };

})();
